import { render, staticRenderFns } from "./RangeSliderNewHandle.vue?vue&type=template&id=6da6f415&scoped=true&"
import script from "./RangeSliderNewHandle.vue?vue&type=script&lang=js&"
export * from "./RangeSliderNewHandle.vue?vue&type=script&lang=js&"
import style0 from "./RangeSliderNewHandle.vue?vue&type=style&index=0&id=6da6f415&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6f415",
  null
  
)

export default component.exports